module.exports = __webpack_public_path__ + "static/media/link_inactive.50a60783.svg";